module.exports = __webpack_public_path__ + "img/img (1).950d676a.jpg";